import styled from 'styled-components';
import { Button, FlexRow, Grid } from '../../../../../ui-toolkit';
import { StyledSummaryItem } from '../../../../shared/Summary/SummaryItem/SummaryItem.styles';

export const StyledUploadGrid = styled(Grid)`
  padding-top: 16px;
  padding-bottom: 16px;
`;

export const StyledDropzoneArea = styled.div`
  align-items: center;
  border: dashed 1px ${(props) => props.theme.colors.primary};
  border-radius: ${(props) => props.theme.spacing.roomyContentPaddingValue}px;
  display: flex;
  justify-content: center;
  padding: ${(props) => props.theme.spacing.roomyContentPaddingValue}px;
`;

export const StyledCancelButton = styled(Button)`
  grid-column: 3;
`;
export const BottomSummaryItem = styled(StyledSummaryItem)`
  padding-bottom: 0;
`;

export const StyledFlexRow = styled(FlexRow)`
  //TODO: use $activeControlBackground once the new colors are in place
  background-color: #f3f4f6;
  align-items: center;
  padding: 10px;
  width: fit-content;
`;

export const StyledGrid = styled(Grid)`
  padding-top: 16px;
  padding-bottom: 16px;
`;
